import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { withOidcSecure } from '@axa-fr/react-oidc';
import HomeLayout from '../../../Layout/HomeLayout';
import CardMenu from '../../CardMenu';
import DynamicCard from '../../../CustomComponents/DynamicCard';
import CardHeading from '../../../CustomComponents/CardHeading';
import { appTheme } from '../../../../helpers/utils/Utils';
import { width } from '../../../CustomComponents/Card/CardStyles';
import { useDocumentTitle } from '../../../../hooks/useDocumentTitle';

const StopPaymentCallSupport = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const cards = useSelector(state => JSON.parse(state.userCards));
    const cardDetails = useSelector(state => state.selectedCardDetails);
    const appThemeData = appTheme(kudzuPlusTrue);

    useDocumentTitle(t('page_title_stop_payment'));

    React.useEffect(() => {
        if (!cardDetails) {
            const fallbackCard = location?.state?.item || cards?.[0];
            if (fallbackCard) {
                dispatch({ type: 'SELECTED_USER_CARD_DETAILS', payload: { selectedCardDetails: fallbackCard } });
            }
        }
    }, [cardDetails, location, cards, dispatch]);

    const handleCardAction = (type) => {
        if (type === t('STOP_A_RECURRING_PAYMENT')) {
            return;
        }
        navigate('/CardServices/CardActionScreen', { state: { item: cardDetails } });
    };

    return (
        <HomeLayout>
            {cardDetails && <CardMenu handleCardAction={handleCardAction} />}
            <div className='md:w-[150px] sm:w-[30px] w-[0px]'></div>
            <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] animate__animated animate__fadeInRight'>
                <DynamicCard
                    header={true}
                    CardRadius={true}
                    cardWidth={width.allpolicies}
                    HeaderRadius={true}
                    isWhite={appThemeData.isWhiteBgForCard}
                    isDarkForKudzu={appThemeData.isDarkBgForCard}
                    backgroundColor={'--cardHeading-bg'}
                    HeaderContent={
                        <CardHeading heading={t('STOP_A_RECURRING_PAYMENT')} />
                    }
                >
                    <div className='mt-10 sm:mx-0 mx-4'>
                        <h1
                            className={`font-hanken-grotesk font-medium text-[26px] leading-[36px] max-w-full ${kudzuPlusTrue ? 'text-[#FFFFFF]' : 'text-[#262B3A]'}`}
                        >
                            {t('STOP_PAYMENT_HEADING')}
                        </h1>
                    </div>

                    <div className={`${kudzuPlusTrue ? '' : 'border-t-[1px] border-[#A3CEBB]'} flex justify-center flex-col sm:mx-0 mx-4 mt-6`}></div>

                    <div
                        className='mt-10 sm:mx-0 mx-4 pb-40'
                    >
                        <p
                            className={`font-hanken-grotesk mb-8 font-normal text-[16px] leading-[24px] max-w-[662px] ${kudzuPlusTrue ? 'text-[#FFFFFF]' : 'text-[#262B3A]'}`}
                        >
                            {t('STOP_PAYMENT_DESCRIPTION')}
                        </p>
                    </div>

                </DynamicCard>
            </div>
        </HomeLayout>
    );
};

export default withOidcSecure(StopPaymentCallSupport);
